import {
  getJobListUrl,
  getJobTemplatesListUrl,
  getTaskListUrl,
} from './api';

export const SEARCH_PARAMETER = 'query';
export const SEARCH_QUERY_INDEX = 'qindex';

export const USER_FILTER_PARAMETER = 'users';
export const STATUSES_FILTER_PARAMETER = 'statuses';
export const TEAM_ASSIGNMENTS_FILTER_PARAMETER = 'teamAssignments';
export const SORT_PARAMETER = 'sort';
export const SORT_ORDER_PARAMETER = 'order';
export const ASC_ORDER = 'ascending';
export const DESC_ORDER = 'descending';

export const ROUTES_NAME = {
  TASK_LIST: 'taskList',
  JOB_TEMPLATES: 'jobTemplates',
  JOBS: 'jobs',
};
export const FILTER_ROUTES = {
  [ROUTES_NAME.TASK_LIST]: getTaskListUrl(),
  [ROUTES_NAME.JOB_TEMPLATES]: getJobTemplatesListUrl(),
  [ROUTES_NAME.JOBS]: getJobListUrl(),
};
